import _classCallCheck from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

/**
 *  Defines the gender of synthesis voices.
 *  Added in version 1.20.0.
 */
export var SynthesisVoiceGender;

(function (SynthesisVoiceGender) {
  /** Gender unknown */
  SynthesisVoiceGender[SynthesisVoiceGender["Unknown"] = 0] = "Unknown";
  /** Female voice */

  SynthesisVoiceGender[SynthesisVoiceGender["Female"] = 1] = "Female";
  /** Male voice */

  SynthesisVoiceGender[SynthesisVoiceGender["Male"] = 2] = "Male";
})(SynthesisVoiceGender || (SynthesisVoiceGender = {}));

export var SynthesisVoiceType;

(function (SynthesisVoiceType) {
  SynthesisVoiceType[SynthesisVoiceType["OnlineNeural"] = 1] = "OnlineNeural";
  SynthesisVoiceType[SynthesisVoiceType["OnlineStandard"] = 2] = "OnlineStandard";
  SynthesisVoiceType[SynthesisVoiceType["OfflineNeural"] = 3] = "OfflineNeural";
  SynthesisVoiceType[SynthesisVoiceType["OfflineStandard"] = 4] = "OfflineStandard";
})(SynthesisVoiceType || (SynthesisVoiceType = {}));
/**
 * Information about Speech Synthesis voice
 * Added in version 1.20.0.
 * @class VoiceInfo
 */


export var VoiceInfo = /*#__PURE__*/function () {
  function VoiceInfo(json) {
    _classCallCheck(this, VoiceInfo);

    this.privStyleList = [];
    this.privVoicePath = "";

    if (!!json) {
      this.privName = json.Name;
      this.privLocale = json.Locale;
      this.privShortName = json.ShortName;
      this.privLocalName = json.LocalName;
      this.privVoiceType = json.VoiceType.endsWith("Standard") ? SynthesisVoiceType.OnlineStandard : SynthesisVoiceType.OnlineNeural;
      this.privGender = json.Gender === "Male" ? SynthesisVoiceGender.Male : json.Gender === "Female" ? SynthesisVoiceGender.Female : SynthesisVoiceGender.Unknown;

      if (!!json.StyleList && Array.isArray(json.StyleList)) {
        var _iterator = _createForOfIteratorHelper(json.StyleList),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var style = _step.value;
            this.privStyleList.push(style);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }

  _createClass(VoiceInfo, [{
    key: "name",
    get: function get() {
      return this.privName;
    }
  }, {
    key: "locale",
    get: function get() {
      return this.privLocale;
    }
  }, {
    key: "shortName",
    get: function get() {
      return this.privShortName;
    }
  }, {
    key: "localName",
    get: function get() {
      return this.privLocalName;
    }
  }, {
    key: "gender",
    get: function get() {
      return this.privGender;
    }
  }, {
    key: "voiceType",
    get: function get() {
      return this.privVoiceType;
    }
  }, {
    key: "styleList",
    get: function get() {
      return this.privStyleList;
    }
  }, {
    key: "voicePath",
    get: function get() {
      return this.privVoicePath;
    }
  }]);

  return VoiceInfo;
}();